import React from 'react';
import { DialogBox } from '@mummssoftware/common-ui';
import { HopeValidationReport } from '@mummssoftware/hope';
import defaults from '../../translations/en.json';

type HopeValidationModalProps = {
  open: boolean;
  hopeDTOProp: string;
  blockingErrors: any[];
  onClose: () => void;
};

export const HopeValidationModal = ({
  open,
  hopeDTOProp,
  blockingErrors,
  onClose,
}: HopeValidationModalProps) => (
  <DialogBox
    open={open}
    handleClick={onClose}
    fullWidth
    disableScrollLock
    maxWidth="lg"
    title={defaults.hopeValidationTitle}
    contentStyle={{ padding: '0px' }}
  >
    <HopeValidationReport rowData={blockingErrors} hopeDTOProp={hopeDTOProp} />
  </DialogBox>
);

export default HopeValidationModal;
